import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Modal, Transition } from 'semantic-ui-react';
import { Field, ModalHeaderContent, PaymentFormWrapper } from './stripe.styled';
import { ControlPropType } from '../../ctrl_proptype';
import { actionTypes } from './stripe-reducer';

const UserSpecifyForm = ({ formDesign, ctrl, showUserAmountForm, updateState, userAmount, startPaymentForm }) => {
  const { OTHERS } = actionTypes;
  const userAmountError = useRef(null);

  const handleClick = () => {
    if (userAmount <= 0) {
      userAmountError.current.textContent = 'Amount cannot be less than or equal to zero';
    } else {
      userAmountError.current.textContent = '';
      startPaymentForm();
    }
  };

  return (
    <>
      <Transition visible={showUserAmountForm} animation="scale" duration={500}>
        <Modal
          closeIcon
          size="tiny"
          onClose={() => updateState(OTHERS, { showUserAmountForm: false })}
          onOpen={() => updateState(OTHERS, { showUserAmountForm: true })}
          open={showUserAmountForm}>
          <Modal.Header>
            <ModalHeaderContent
              style={{
                '--fontFamily': formDesign.old.form_font,
              }}>
              <span>Enter an amount</span>
            </ModalHeaderContent>
          </Modal.Header>
          <Modal.Content content>
            <PaymentFormWrapper
              style={{
                '--fontFamily': formDesign.old.form_font,
              }}>
              <form>
                <Field>
                  <label htmlFor={`${ctrl.internal_id}-stripeAmount`}>Amount in {ctrl.props.currency}</label>
                  <Input
                    type="number"
                    step="0.01"
                    min="0.01"
                    id={`${ctrl.internal_id}-stripeAmount`}
                    value={userAmount}
                    onChange={(e) => updateState(OTHERS, { userAmount: e.target.value })}
                  />
                  {/* Amount error */}
                  <span ref={userAmountError} />
                </Field>
              </form>
            </PaymentFormWrapper>
          </Modal.Content>
          <Modal.Actions>
            <Button
              content="Continue"
              labelPosition="right"
              icon="checkmark"
              onClick={() => handleClick()}
              style={{ marginBottom: '15px' }}
            />
          </Modal.Actions>
        </Modal>
      </Transition>
    </>
  );
};

export default UserSpecifyForm;

UserSpecifyForm.defaultProps = {
  formDesign: null,
};

UserSpecifyForm.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  showUserAmountForm: PropTypes.bool.isRequired,
  updateState: PropTypes.func.isRequired,
  startPaymentForm: PropTypes.func.isRequired,
  userAmount: PropTypes.number.isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
